<app-nav></app-nav>

<main class="verify-email-page">
  <section class="auth-hero brand-section">
    <div class="hero-orb hero-orb-blue"></div>
    <div class="hero-orb hero-orb-green"></div>

    <div class="auth-card-shell">
      <div class="auth-card">

        @if (status === 'loading') {
          <div class="state">
            <div class="spinner-ring"><mat-spinner diameter="40" strokeWidth="3"></mat-spinner></div>
            <span class="brand-eyebrow">One sec</span>
            <h1>Verifying your email</h1>
            <p class="brand-lede">Hold tight while we confirm the link.</p>
          </div>
        }

        @if (status === 'success') {
          <div class="state state-success">
            <div class="badge-circle badge-success">
              <mat-icon>check</mat-icon>
            </div>
            <span class="brand-eyebrow">All set</span>
            <h1>You're verified.</h1>
            <p class="brand-lede">
              Email confirmed — head back to the app and you're ready to go.
            </p>
            <a class="brand-btn brand-btn-primary brand-btn-large" routerLink="/download">
              <mat-icon>download</mat-icon>
              Download the app
            </a>
          </div>
        }

        @if (status === 'error') {
          <div class="state state-error">
            <div class="badge-circle badge-error">
              <mat-icon>priority_high</mat-icon>
            </div>
            <span class="brand-eyebrow">Hmm</span>
            <h1>That didn't go through.</h1>
            <p class="brand-lede">{{ errorMessage }}</p>
            <p class="auth-helper">
              Open the app and request a new verification email, or
              <a routerLink="/contact">contact support</a> if this keeps happening.
            </p>
          </div>
        }

        @if (status === 'no-token') {
          <div class="state state-error">
            <div class="badge-circle badge-error">
              <mat-icon>link_off</mat-icon>
            </div>
            <span class="brand-eyebrow">Invalid link</span>
            <h1>This link is missing pieces.</h1>
            <p class="brand-lede">
              The verification token wasn't found. Use the original link from your email,
              or request a new one from the app.
            </p>
            <p class="auth-helper">
              Still stuck? <a routerLink="/contact">Get in touch</a> and we'll help.
            </p>
          </div>
        }

      </div>
    </div>
  </section>
</main>

<app-footer></app-footer>
